<style lang="scss" scoped>

	$bgColor: #4d8ab7;

    .video-player-container {
        position:relative;
        height: 480px;
    }

    .instructions {
        font-weight: bold;
        color: #4d8ab7;
        font-size: 1.2em;
    }

    #video-player {
        width: 100%;
        height: 100%;
    }

    .question-overlay {
		position:absolute;
        width: 100%;
        height: 100%;
        top: 0;
    	opacity: 0.9;
    	background-color: white;
    }

    .question-container {
	    position:absolute;
        width: 100%;
        height: 100%;
        top: 0;
        color: white;
    }

    .question, .answer {
    	background-color: $bgColor;
    }

    .question {
	    border-radius: 5px;
    }

    .answer-list {
	    position:absolute;
        width: 80%;
        height: 70%;
        top: 25%;
        left: 10%;
		color: white;
    }
    .answer {
    	cursor: pointer;
    	border-radius: 5px;
		width: 50%;
		margin: 0 auto;
    }

    .answer:hover {
    	background-color: #d76633;
    }

    .continue-button {
    	position: absolute;;
	    width: 30%;
	    top: 36%;
	    left: 35%;
	    font-size: 1.5em;
    }


</style>

<template>
	<div>
        <div class="instructions mb-4">
	        <slot name="instructions">
	            Click Play to start the video. You will be asked to pause to reflect and answer a couple questions along the way. Make sure you write down the quiz code at the end of the video. You will need this to access the Knowledge Quiz.
	        </slot>
	    </div>

		<div class='video-player-container'>

			<div id='video-player'></div>

			<div v-show="isQuestionBlockDisplayed" class='question-overlay'></div>

			<transition name="fade">
				<div v-show="isQuestionBlockDisplayed" class='question-container p-3'>
					<div class='question mb-5 p-3'>{{ question }}</div>
				</div>
			</transition>

			<transition name="fade">
				<div v-show="isQuestionBlockDisplayed" class='answer-list'>
					<div v-for="(item,index) in answerChoicesAsBullets" class='answer mb-4 p-3' @click="onClickAnswer($event)">
						{{ item }}
					</div>
				</div>
			</transition>

			<div v-show="isContinueButtonDisplayed">
				<button type='button' class='continue-button btn btn-success py-2' @click="continueVideo">Yes, I am ready to continue.</button>
			</div>
		</div>
	</div>
</template>

<script>

	import { mapState } from 'vuex';

	export default {
		name: 'panopto-video-embed',
		props: ['videoId'],
		data() {
			return {
				embedVideo: null,
				interval: null,
				intervalDuration: 500,
				isQuestionBlockDisplayed: false,
				isContinueButtonDisplayed: false,
				feedbackText: "",
				externalLoaded: false,
				question: "",
				answerChoices: [],
				stopPoints: [],
				currentStopPoint: null,
				completedStopPoints: {},
				videoQuizzes: [],
				seekBuffer: 10,
			};
		},

		methods: {
	        onPanoptoEmbedApiReady: function() {

	        	this.embedVideo = new EmbedApi("video-player", {
					width: "100%",
					height: "100%",
					serverName: "uncch.hosted.panopto.com",
					sessionId: this.videoId,
					videoParams: { // Optional parameters
					//interactivity parameter controls if the user sees table of contents, discussions, notes, & in-video search
						"interactivity": "none",
						"showtitle": "true"
					},
					events: {
						"onIframeReady": this.onPanoptoIframeReady,
						"onReady": this.onPanoptoVideoReady,
						"onStateChange": this.onPanoptoStateUpdate,
						"onError": this.onPanoptoError
					}
				});
	        },

	        onPanoptoError: function() {
	        },

	        onPanoptoIframeReady: function() {
	            // The iframe is ready and the video is not yet loaded (on the splash screen)
	            // Load video will begin playback
	            this.embedVideo.loadVideo();
	        },

	        onPanoptoVideoReady: function() {
	            // The video has successfully been loaded by onPanoptoIframeReady
	        },

         	onPanoptoStateUpdate: function(state) {
	            if (state === PlayerState.Playing) {
	            	this.onPlayingStatusUpdate();
	            } else if(state === PlayerState.Paused) {
	            	this.onPausedStatusUpdate();
	            }
	        },

	        /**
	         * Handler for PLAYING status
	         */
	        onPlayingStatusUpdate() {
	        	let vm = this;

				this.interval = this.interval || setInterval(function() {
					var time = Math.floor(vm.embedVideo.getCurrentTime()).toString();

					if(parseInt(time) > parseInt(vm.getFirstIncompleteStopPoint())) {
						vm.embedVideo.seekTo(parseInt(vm.getFirstIncompleteStopPoint()) - vm.seekBuffer);
					}

					if(!vm.atStopPoint()) {
						vm.currentStopPoint = null;
					}

					if(vm.atStopPoint() && !vm.alreadyStopped()) {

						let currentQuiz = vm.videoQuizzes[time];

						vm.question = currentQuiz.question_text;
						vm.answerChoices = currentQuiz.answer_choices;

						vm.showQuestionBlock();

						vm.currentStopPoint = time;

						vm.embedVideo.pauseVideo();
					}

				}, this.intervalDuration);
			},

	        /**
	         * Handler for PAUSED status
	         */
	        onPausedStatusUpdate() {
	        },

			atStopPoint() {
				let time = Math.floor(this.embedVideo.getCurrentTime()).toString();
				return this.stopPoints.includes(time);
			},

	        alreadyStopped: function() {
				return this.currentStopPoint == Math.floor(this.embedVideo.getCurrentTime()).toString();
	        },

	        onClickAnswer: function (event) {
	        	this.continueVideo();
	        },

	        continueVideo: function() {
	        	this.isQuestionBlockDisplayed = false;
	        	this.isContinueButtonDisplayed = false;
				this.completedStopPoints[this.currentStopPoint] = true;
	        	this.embedVideo.playVideo();
	        },

	        clearStopPointInterval: function() {
                clearInterval(this.interval);
                this.interval = null;
	        },

	        showQuestionBlock: function() {
				this.isQuestionBlockDisplayed = true;
				if(this.answerChoices.length == 0) {
					// show continue button if there are no answer choices
					this.isContinueButtonDisplayed = true;
				}
	        },
	        getFirstIncompleteStopPoint() {
				let vm = this;
				let incompleteStopPoints = this.stopPoints.filter(x => !Object.keys(vm.completedStopPoints).includes(x));
				return incompleteStopPoints[0];
	        }

		},
		computed: {
            ...mapState([
                'trainings',
            ]),
			answerChoicesAsBullets: function() {
				// prefix each item with a capital letter starting with 'A'
				return this.answerChoices.map((item,index) => String.fromCharCode(65 + index) + ") " + item);
			},
		},
		watch: {
		},
		mounted() {
			this.onPanoptoEmbedApiReady();
		}
	}
</script>
